import DispatchPage from "./DispatchPage";

export default DispatchPage;
